
































import Vue, { PropType } from 'vue'
import UiProductBox from '../UiProductBox'
import { ProductCard } from './UiProductCards.types'

export default Vue.extend({
  name: 'UiProductCards',
  components: {
    UiProductBox
  },
  props: {
    header: {
      type: String,
      default: ''
    },
    headerTag: {
      type: String,
      default: 'h2'
    },
    productCards: {
      type: Array as PropType<ProductCard[]>,
      default: () => []
    }
  },
  computed: {
    isCardsCenter (): boolean {
      return this.productCards.length < 3
    }
  }
})
